var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-header", {
    attrs: {
      "cart-route": "cart",
      "checkout-route": "checkout",
      collapsed: _vm.headerCollapsed,
      cart: _vm.cart,
      "user-logged-in": _vm.userLoggedIn,
      processing: _vm.processing,
      search: _vm.search,
      "marketplace-categories": _vm.marketplaceCategories,
      customer: _vm.customer,
      "menu-links": _vm.menuLinks,
      "is-mobile": _vm.isMobile,
      "is-mobile-sales-page": _vm.isMobileSalesPage,
      "scrolling-up": _vm.scrollingUp,
      "hide-fixed-header": _vm.hideFixedHeader,
      "current-scroll-top": _vm.currentScrollTop
    },
    on: {
      navigate: _vm.handleNavigation,
      "log-out": _vm.handleLogOut,
      "search-input": _vm.handleSearchInput,
      "perform-search": _vm.performSearch
    },
    scopedSlots: _vm._u([
      {
        key: "logo",
        fn: function() {
          return [
            _c(
              "router-link",
              { attrs: { to: { name: "home" }, "aria-label": "Home link" } },
              [_c("logo", { attrs: { header: "header" } })],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "social",
        fn: function() {
          return [_c("social", { attrs: { menu: "menu" } })]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }